import { SubAPI } from "./SubAPI";
export class Files extends SubAPI {
    downloadLink(id) { let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "attachment"; return "/api/file/download?id=" + id + "&type=" + type; }
    upload(input) { return this.fetcher.postFormData("/api/file", { file: input.file, name: input.name || "", convert2pdf: input.convert2pdf ? "true" : "false" }); }
} // file.pdf => .pdf
export function ext(fileName) { const dot = fileName.lastIndexOf("."); if (dot === -1) {
    return "";
} return fileName.substring(dot); }
